<template>
    <div id="contact">
        <div class="hero">
            <p>Let's Get <br />You Started!</p>
            <img src="https://elitecrafthomes.com/static_files/images/ContactUs_Header.jpeg" alt="">
        </div>

        <h1>Contact Us</h1>
        <div class="alerting">
            <v-alert v-model="contact.success" type="success" dismissible>{{ contact.alertMessage }}</v-alert>
            <v-alert v-model="contact.failure" type="error" dismissable>{{ contact.alertMessage }}</v-alert>
        </div>

        <div class="contact-wrapper">
            <div class="contact-top">
                <div class="contact-icons">
                    <p class="contact-title">Get in touch with us!</p>
                    <div>
                        <v-icon left style="display: table-cell; vertical-align: middle;">fas fa-phone</v-icon>
                        <p><a href="tel:1-801-451-6525"> (801) 451-6525</a></p>
                    </div>
                    <div>
                        <v-icon left style="display: table-cell; vertical-align: middle;">far fa-envelope</v-icon>
                        <p><a href="mailto:info@elitecrafthomes.com"> info@elitecrafthomes.com</a></p>
                    </div>
                    <div>
                        <v-icon left style="display: table-cell; vertical-align: middle;">fas fa-home</v-icon>
                        <p><a href="https://www.google.com/maps/place/49+Main+St,+Farmington,+UT+84025/@40.9811857,-111.890206,17z/data=!3m1!4b1!4m5!3m4!1s0x8752ff3c172284b1:0xb9c818901b3b1568!8m2!3d40.9811817!4d-111.8880173"
                           target="_blank" rel="noopener noreferrer">49 North Main St<br><span>Farmington UT 84025</span></a></p>
                    </div>
                </div>

                <div class="form" v-model="contact.valid">
                    <v-text-field v-model="contact.contact.full_name" :rules="contact.nameRules" label="Full Name"
                                  required style="margin: auto 0 10px 0;"></v-text-field>
                    <v-text-field v-model="contact.contact.email" :rules="contact.emailRules" label="Email Address"
                                  required style="margin: auto 0 10px 0;"></v-text-field>
                    <v-text-field v-model="contact.contact.phone" :rules="contact.phoneRules" label="Phone Number"
                                  required style="margin: auto 0 10px 0;"></v-text-field>
                    <v-textarea v-model="contact.contact.message" :rules="contact.messageRules" label="Message"
                                  required style="margin: auto 0 10px 0"></v-textarea>
                    <button @click.stop="sendEmail(contact.contact)">Contact</button>
                </div>
            </div>
        </div>

        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3011.9898042629407!2d-111.89096773243898!3d40.98170409284392!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8752ff3c172284b1%3A0xb9c818901b3b1568!2s49+Main+St%2C+Farmington%2C+UT+84025!5e0!3m2!1sen!2sus!4v1525841096609"
                width="100%" height="450" frameborder="0" style="border:0" allowfullscreen class="google_maps"></iframe>
    </div>
</template>

<script>

    import axios from 'axios'

    const data = {
        contact: {
            contact: {
                full_name: '',
                first_name: '',
                last_name: '',
                email: '',
                phone: '',
                message: '',

            },
            valid: false,
            alertMessage: '',
            success: false,
            failure: false,
            nameRules: [
                v => !!v || 'Full Name is required',
                // v => v.length <= 10 || 'Name must be less than 10 characters'
            ],
            emailRules: [
                v => !!v || 'E-mail is required',
                v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
            ],
            phoneRules: [
                v => !!v || 'Phone number is required',
                v => /^\d{10}$/.test(v) || 'Phone number must be a valid 10 digit number'
            ],
            messageRules: [
                v => !!v || 'Message is required',
                v => v.length <= 160 || 'Message must be less than 160 characters'
            ]
        }
    };

    const apiToken = require('../../credentials').API_TOKEN;
    const urlPath = require('../../credentials').URL_PATH;

    export default {
        name: 'Contact',
        data() {
            return data;
        },
        methods: {
            sendEmail(contact) {
                if (contact.full_name === '' || contact.email === '' || contact.phone === '' || contact.message === '') {
                    this.contact.alertMessage = "Please fill out all form details";
                    this.contact.success = false;
                    this.contact.failure = true;
                }
                contact.first_name = contact.full_name.split(' ')[0];
                contact.last_name = contact.full_name.split(' ')[1];
                console.log(contact.first_name, contact.last_name);


                axios.post(urlPath + 'clients/', contact, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Headers': 'true',
                        'Access-Control-Allow-Origin': '*',
                        'Authorization': `Token ${apiToken}`
                    }
                })
                    .then((res) => {
                        console.log(res);
                        this.contact.alertMessage = res.data.detail;
                        this.contact.failure = false;
                        this.contact.success = true;

                    }, (res) => {
                        console.log(res);
                        this.contact.alertMessage = res.data.detail;
                        this.contact.success = false;
                        this.contact.failure = true;
                    })
            }
        }
    }

</script>

<style lang="scss" scoped>

    @font-face {
        font-family: "Tahu";
        src: url("https://elitecrafthomes.com/static_files/fonts/Tahu.ttf"),
        url("https://elitecrafthomes.com/static_files/fonts/Tahu.otf") format('opentype');
    }

    @font-face {
        font-family: "LibreBaskerville Bold";
        src: url("https://elitecrafthomes.com/static_files/fonts/LibreBaskerville-Bold.ttf")
    }

    * {
        box-sizing: border-box;
    }

    h1 {
        margin: 50px 0;
        text-align: center;
        font-family: 'LibreBaskerville Bold', 'Muli', 'Avenir Next', 'Helvetica Neue', serif;
    }

    a {
        text-decoration: none;
        color: #2d3e4f;
    }

    p {
        font-size: 16px;
    }

    .form {
        width: 50%;
        margin: 0 auto 25px auto;
        text-align: center;
        button {
            font-size: 20px;
            border: 3px solid white;
            background-color: #425152;
            color: white;
            width: 165px;
            padding: 7px 0;
            text-decoration: none;
            text-align: center;
            -webkit-box-shadow: -1px 2px 3px 1px rgba(0,0,0,0.71);
            -moz-box-shadow: -1px 2px 3px 1px rgba(0,0,0,0.71);
            box-shadow: -1px 2px 3px 1px rgba(0,0,0,0.71);
        }
    }

    .hero {
        position: relative;
        background-color: rgba(0, 0, 0, 0.65);
        width: 100%;
        height: 530px;
        max-height: 530px;
        max-width: 100vw;
        br {
            display: none;
        }
        p {
            font-size: 72px;
            font-family: "Tahu", cursive;
            color: white;
            position: absolute;
            top: 50%;

            -webkit-transform: translateY(-50%);
            -moz-transform: translateY(-50%);
            -ms-transform: translateY(-50%);
            -o-transform: translateY(-50%);
            transform: translateY(-50%);
            z-index: 899;
            padding-left: 25px;
            line-height: 1.4;
        }
        img {
            height: 530px;
            max-height: 530px;
            width: 100%;
            max-width: 100vw;
            position: absolute;
            top: 0;
            left: 0;
            object-fit: fill;
            opacity: .5
        }
    }
    .alerting {
        max-width: 1100px;
        width: 100%;
        margin: 0 auto 50px auto;
    }


    .google_maps {
        margin-top: 25px;
    }

    @media screen and (min-width: 1025px) {
        .contact-wrapper {
            position: relative;
            max-width: 1020px;
            width: 100%;
            height: 550px;
            margin: 0 auto;
            .contact-top {
                position: absolute;
                width: 100%;
                left: 50%;
                height: 550px;
                margin: 0 auto;
                -webkit-transform: translateX(-50%);
                -moz-transform: translateX(-50%);
                -ms-transform: translateX(-50%);
                -o-transform: translateX(-50%);
                transform: translateX(-50%);


                .contact-icons {
                    max-width: 300px;
                    width: 100%;
                    text-align: center;
                    margin: 0 auto;
                    position: absolute;
                    left: 0;
                    top: 30%;
                    -webkit-transform: translateY(-50%);
                    -moz-transform: translateY(-50%);
                    -ms-transform: translateY(-50%);
                    -o-transform: translateY(-50%);
                    transform: translateY(-50%);
                    div {
                        display: table;
                    }
                    p:not(.contact-title) {
                        margin: 0;
                        padding: 8px 0 8px 12px;
                        text-align: left;
                        font-size: 18px;
                    }
                    * {
                        text-align: left;
                    }
                    .contact-title {
                        font-weight: 400;
                        font-size: 24px;
                    }
                }

                .form {
                    max-width: 720px;
                    width: 100%;
                    margin: 0 auto 25px auto;
                    text-align: center;
                    position: absolute;
                    top: 0;
                    right: 0;
                    button {
                        font-size: 20px;
                        border: 3px solid white;
                        background-color: #425152;
                        color: white;
                        width: 165px;
                        padding: 7px 0;
                        text-decoration: none;
                        text-align: center;
                        float: left;
                        -webkit-box-shadow: -1px 2px 3px 1px rgba(0, 0, 0, 0.71);
                        -moz-box-shadow: -1px 2px 3px 1px rgba(0, 0, 0, 0.71);
                        box-shadow: -1px 2px 3px 1px rgba(0, 0, 0, 0.71);
                    }
                }
            }
        }

        .hero {
            p {
                left: 50%;
                top: 50%;
                -webkit-transform: translate(-50%, -50%);
                -moz-transform: translate(-50%, -50%);
                -ms-transform: translate(-50%, -50%);
                -o-transform: translate(-50%, -50%);
                transform: translate(-50%, -50%);
            }
        }
    }

    /* Smartphones (portrait) ----------- */
    @media only screen and (max-width: 450px) {
        .alerting {
            max-width: 400px;
            padding: 0 25px;
        }
        .hero {
            position: relative;
            background-color: rgba(0, 0, 0, 0.65);
            width: 100%;
            height: 430px;
            max-height: 430px;
            max-width: 100vw;
            overflow: hidden;
            br {
                display: none;
            }
            p {
                font-size: 3em;
                font-family: "Tahu", cursive;
                color: white;
                position: absolute;
                top: 50%;
                -webkit-transform: translateY(-50%);
                -moz-transform: translateY(-50%);
                -ms-transform: translateY(-50%);
                -o-transform: translateY(-50%);
                transform: translateY(-50%);
                z-index: 899;
                padding-left: 25px;
                line-height: 1.4;
            }
            img {
                height: 430px;
                max-height: 430px;
                width: 100%;
                max-width: 100vw;
                position: absolute;
                top: 0;
                left: 0;
                object-fit: fill;
                opacity: .5;
                -webkit-transform: scaleX(1.5);
                -moz-transform: scaleX(1.5);
                -ms-transform: scaleX(1.5);
                -o-transform: scaleX(1.5);
                transform: scaleX(1.5);
            }
        }


        .contact-icons {
            text-align: center;
            margin: 0 auto 40px auto;
            position: relative;
            width: 60vw;

            div {
                display: table;
            }
            p:not(.contact-title) {
                margin: 0;
                padding: 5px 0 5px 12px;
            }
            * {
                text-align: left;
            }

            .contact-title {

                font-size: 20px;
                text-align: center;
                font-weight: bold;
            }

        }

        .icon {
            width: 25px;
            height: 25px;
        }

        .hero {
            br {
                display: block;
            }
        }

        .form {
            width: 75%;
            margin: 0 auto 25px auto;
            text-align: center;
            button {
                font-size: 16px;
                border: 3px solid white;
                background-color: #425152;
                color: white;
                width: auto;
                padding: 4px 30px;
                text-decoration: none;
                text-align: center;
                -webkit-box-shadow: -1px 2px 3px 1px rgba(0,0,0,0.71);
                -moz-box-shadow: -1px 2px 3px 1px rgba(0,0,0,0.71);
                box-shadow: -1px 2px 3px 1px rgba(0,0,0,0.71);
            }
        }
    }

    @media screen and (min-width: 451px) and (max-width: 1024px) {
        .alerting {
            max-width: 700px;
            padding: 0 25px;
        }
        h1 {
            font-size: 26px;
        }

        .hero {
            width: 100%;
            height: 500px;
            max-height: 500px;
            max-width: 100vw;
            br {
                display: block;
            }
            p {
                font-size: 3.5em;
                padding-left: 75px;
                line-height: 1.4;
            }
            img {
                height: 500px;
                max-height: 500px;
                width: 100%;
                max-width: 100vw;
            }
        }

        .contact-icons {
            margin: 0 auto 40px auto;
            position: relative;
            max-width: 35vw;
            width: 100%;

            div {
                display: table;
            }
            p:not(.contact-title) {
                margin: 0;
                padding: 5px 0 5px 12px;
                font-size: 18px;
            }
            * {
                text-align: left;
            }

            .contact-title {

                font-size: 22px;
                text-align: center;
                font-weight: bold;
            }

        }
        .form {
            width: 70%;
            button {
                font-size: 18px;
                width: auto;
                padding: 4px 30px;
                float: left;
            }
        }

        .google_maps {
            margin-top: 60px;
        }

    }

    @media screen and (min-width: 769px) and (max-width: 1024px) {
        .contact-icons {
            max-width: 25vw;
            width: 100%;
        }

        .form {
            width: 60%;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue